import React from "react";

interface ItemsPerPageSelectorProps {
  itemsPerPage: number;
  onItemsPerPageChange: (value: number) => void;
  options?: number[];
  totalItems: number;
  startItem: number;
  endItem: number;
}

export function ItemsPerPageSelector({
  itemsPerPage,
  onItemsPerPageChange,
  options = [12, 18, 24],
  totalItems,
  startItem,
  endItem,
}: ItemsPerPageSelectorProps) {
  return (
    <div className="flex items-center">
      <span className="text-sm text-gray-600 mr-2">每頁顯示個數</span>
      <select
        className="border rounded px-2 py-1 text-sm"
        value={itemsPerPage}
        onChange={(e) => onItemsPerPageChange(Number(e.target.value))}
      >
        {options.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
      <span className="ml-4 text-sm text-gray-600">{totalItems > 0 ? `${startItem}-${endItem}/${totalItems}` : "0/0"}</span>
    </div>
  );
}
